interface OrphanProtectedProps {
  string: string;
}

const OrphanProtected: React.FunctionComponent<OrphanProtectedProps> = ({ string }) => {
  const arr = string.trim().split(' ');
  const last = arr.pop();
  return arr.length > 1 ? (
    <>
      {arr.join(' ')}&nbsp;{last}
    </>
  ) : (
    <>{string}</>
  );
};

export default OrphanProtected;
